<h1 transloco="sharedLabNotFound1">Access to results are expired or unavailable. Please contact the patient that generated the lab results so they can generate a new access</h1>
<h1 class="icon-broken-heart"></h1>
<h1 transloco="sharedLabNotFound2">We apologize for any inconvenience</h1>

<div class="text-center">
    <button class="ab_button filled" (click)="goBack()" transloco="return">Return</button>
</div>